import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import FeatherIcon from "feather-icons-react";

// Telegram-style: tap an avatar/logo to see it full-size, tap anywhere (the
// backdrop, the close icon, or Escape) to dismiss. Portaled straight into
// <body>, not rendered in place - see PageLoader's own comment for why: any
// ancestor with a CSS transform/filter (even a mid-animation one, e.g.
// CustomModal's own opening transform) becomes the containing block for a
// position:fixed descendant, clipping it to that ancestor's box instead of
// the real viewport.
const PhotoLightbox = ({ src, alt, onClose }) => {
    useEffect(() => {
        if (!src) return;
        const handleKey = (e) => { if (e.key === "Escape") onClose(); };
        document.addEventListener("keydown", handleKey);
        return () => document.removeEventListener("keydown", handleKey);
    }, [src, onClose]);

    if (!src) return null;

    return ReactDOM.createPortal(
        <div className="photo-lightbox" onClick={onClose}>
            <div className="photo-lightbox-close" onClick={onClose}>
                <FeatherIcon icon="x" size={26} />
            </div>
            <img src={src} alt={alt || ""} onClick={(e) => e.stopPropagation()} />
        </div>,
        document.body
    );
};

export default PhotoLightbox;
